import axios from 'axios'

export default {
  /* 店頭購入履歴を取得 */
  async getHistories() {
    return await axios.get('users/purchase_histories?purchase_place=shop')
  },
  /* 店頭購入履歴の詳細を取得 */
  async getDetails({ salesId }) {
    return await axios.get(`users/purchase_histories/${salesId}?purchase_place=shop`)
  },
  /* 最新店頭購入履歴を取得（ホームで使用） */
  async getLatestHistory() {
    return await axios.get('users/purchase_histories/latest')
  },
}
